import React from "react";
import { AiFillStar } from "react-icons/ai";
import { CiStar } from "react-icons/ci";
import { useTheme } from "../../context/ThemeContext";

const RatingFilter = ({
  currentRating,
  onRatingChange,
  showResetButton = true,
  onResetRating,
  disabled = false,
  title = "Valorizacion",
  starSize = "text-xl",
  containerClassName = "",
  starContainerClassName = "gap-2",
  resetText = "Sin calificacion",
  customAccentColor,
}) => {
  const { getColor, getBackground, getTextColor, getMuiTextStyle } = useTheme();
  const accentColor = customAccentColor || getColor("primary", "#ae1d22");
  const textSecondary = getTextColor("textSecondary", "#6c757d").color;
  const borderColor = getColor("border", "#e5e7eb");
  const surfaceColor = getBackground("surface", "#ffffff").backgroundColor;

  const ratings = [
    { value: 5, label: "5 estrellas" },
    { value: 4, label: "4 estrellas y mas" },
    { value: 3, label: "3 estrellas y mas" },
    { value: 2, label: "2 estrellas y mas" },
    { value: 1, label: "1 estrella y mas" },
  ];

  const handleRatingClick = rating => {
    if (!disabled) {
      onRatingChange(rating);
    }
  };

  const handleResetClick = () => {
    if (!disabled && onResetRating) {
      onResetRating();
    }
  };

  const getRatingItemStyle = isSelected => ({
    color: disabled ? textSecondary : accentColor,
    opacity: disabled ? 0.5 : 1,
    fontWeight: isSelected ? 600 : 400,
  });

  const renderStars = count => (
    <div className={`flex justify-start items-start ${starContainerClassName}`}>
      {[...Array(5)].map((_, index) => (
        <span key={index} className={starSize}>
          {index < count ? <AiFillStar /> : <CiStar />}
        </span>
      ))}
    </div>
  );

  return (
    <div
      className={`py-3 flex flex-col gap-4 rounded-lg p-4 ${containerClassName}`}
      style={{
        backgroundColor: surfaceColor,
        border: `1px solid ${borderColor}`,
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
      }}>
      <h2 className="font-medium text-lg" style={getMuiTextStyle("textPrimary")}>
        {title}
      </h2>

      <div className="flex flex-col gap-3">
        {ratings.map(rating => (
          <div
            key={rating.value}
            onClick={() => handleRatingClick(rating.value)}
            className={`flex justify-between items-center cursor-pointer transition-opacity hover:opacity-80 ${disabled ? "cursor-not-allowed" : ""}`}
            style={getRatingItemStyle(currentRating === rating.value)}
            title={rating.label}
            aria-label={`Filtrar por ${rating.label}`}>
            {renderStars(rating.value)}
            <span className="text-sm ml-2" style={{ color: textSecondary }}>
              y mas
            </span>
          </div>
        ))}

        {showResetButton && (
          <div
            onClick={handleResetClick}
            className={`flex justify-between items-center cursor-pointer transition-opacity hover:opacity-80 ${disabled ? "cursor-not-allowed" : ""}`}
            style={getRatingItemStyle(!currentRating)}
            title={resetText}
            aria-label={resetText}>
            <div className={`flex justify-start items-start ${starContainerClassName}`}>
              {[...Array(5)].map((_, index) => (
                <span key={index} className={starSize}>
                  <CiStar />
                </span>
              ))}
            </div>
            <span className="text-sm ml-2" style={{ color: textSecondary }}>
              {resetText}
            </span>
          </div>
        )}
      </div>

      {currentRating && !disabled && (
        <div className="mt-2 pt-2" style={{ borderTop: `1px solid ${borderColor}` }}>
          <div className="flex items-center justify-between">
            <span className="text-sm" style={{ color: textSecondary }}>
              Filtrado por:
              <span className="font-medium ml-1">
                {currentRating} estrella{currentRating > 1 ? "s" : ""}
              </span>
            </span>
            {showResetButton && onResetRating && (
              <button
                onClick={handleResetClick}
                className="text-xs underline transition-opacity hover:opacity-80"
                style={{ color: accentColor }}
                type="button">
                Quitar filtro
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

RatingFilter.defaultProps = {
  currentRating: "",
  onRatingChange: () => {},
  showResetButton: true,
  onResetRating: null,
  disabled: false,
  title: "Valorizacion",
  starSize: "text-xl",
  containerClassName: "",
  starContainerClassName: "gap-2",
  resetText: "Sin calificacion",
  customAccentColor: undefined,
};

export default RatingFilter;

